import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { colors } from '../utils/colors';

export function SimpleTable({ children }) {
  return <StyledTable>{children}</StyledTable>;
}

SimpleTable.propTypes = {
  children: PropTypes.array.isRequired,
};

const StyledTable = styled.table`
  border-collapse: collapse;
  border: none;
  width: 100%;
  color: ${colors.darkGrey};
  text-align: center;

  tr {
    border-top: 1px solid ${colors.lightGrey};
  }
  thead {
    tr {
      border-top: none;
      font-weight: bold;
    }
  }
  th {
    padding: 10px;
  }
  td {
    border: none !important;
    padding: 10px;
  }
`;
